export const creatorsReportEndpointIds = {
    CRON_CREATE_CREATORS_REPORT: 'CRON_CREATE_CREATORS_REPORT',
    SQS_CREATE_CREATORS_REPORT: 'SQS_CREATE_CREATORS_REPORT',
    INIT_REFRESH_CREATORS_REPORT: 'INIT_REFRESH_CREATORS_REPORT',
    GET_CREATORS_REPORT: 'GET_CREATORS_REPORT',
    GENERATE_CREATORS_REPORT: 'GENERATE_CREATORS_REPORT',
    GET_CREATORS_REPORT_STATUS: 'GET_CREATORS_REPORT_STATUS',
};
